module.exports = __webpack_public_path__ + "img/zz2.2cf18871.png";